import { render, staticRenderFns } from "./DataRecordHeaderItemValue.vue?vue&type=template&id=c8b5334e&scoped=true&"
import script from "./DataRecordHeaderItemValue.vue?vue&type=script&lang=js&"
export * from "./DataRecordHeaderItemValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b5334e",
  null
  
)

export default component.exports